import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Autocomplete, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useState, useEffect } from "react";
import { createButtonBg, primaryColor } from '../../constant';
import { get_data, post_data } from '../../api';
import toast from 'react-hot-toast';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    boxShadow: 24,
    p: 4,
};

export default function AddEmployeeModal({ open, setOpen, selectedRow, isUpdate, getAllEmployees }) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isUpdate) {
            setName(selectedRow?.name);
            setEmail(selectedRow?.email);
            setPhone(selectedRow?.phone);
            setPassword(selectedRow?.password);
            setRole(selectedRow?.role || '');
        }
    }, [selectedRow]);

    const handleError = (error, label) => {
        setErrors((prev) => ({ ...prev, [label]: error }));
    };


    const validation = () => {
        let error = false;
        if (!name) {
            error = true;
            handleError('Please input Name...', 'name');
        }
        if (!email) {
            error = true;
            handleError('Please input Email...', 'email');
        }
        if (!phone) {
            error = true;
            handleError('Please input Phone...', 'phone');
        }

        if (!password) {
            error = true;
            handleError('Please input Phone...', 'password');
        }
        if (!role) {
            error = true;
            handleError('Please input role...', 'role');
        }
        return error;
    };

    const handleClose = () => {
        if (isUpdate) {
            // setEditModelOpen(false);
        } else {
            setOpen(false);
            setName('');
            setEmail('');
            setPhone('');
            setPassword('');
            setRole('');
        }
    };

    const handleSubmit = async () => {
        const error = validation();
        if (!error) {
            try {
                let data;
                setLoading(true);

                if (isUpdate) {
                    data = await post_data(`employee/update-employee`, { name, email, phone, password, role, employeeId: selectedRow?._id });
                    setOpen(false);
                } else {
                    data = await post_data(`employee/create-employee`, { name, email, phone, password, role });
                    setOpen(false);
                }
                if (data?.status === true) {
                    toast.success(data?.message || isUpdate ? 'Employee updated successful!' : 'Employee created successful!');
                    getAllEmployees()
                } else {
                    toast.error(data?.response?.data?.message || 'Something went wrong!');
                }
            } catch (error) {
                toast.error('An error occurred. Please try again.');
            } finally {
                setLoading(false);
            }
        }
    };
    // console.log("fuelList?.find((item)=>fuelId?.includes(item?._id) )",fuelList?.find((item)=>fuelId?.includes(item?._id) ))
    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Typography id="modal-title" variant="h6" component="h2">
                            {isUpdate ? 'Edit Employee' : 'Add Employee'}
                        </Typography>
                        <Grid container spacing={2} style={{ marginTop: 10 }}>
                            <Grid item xs={12}>
                                <TextField
                                    label="Employee Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    fullWidth
                                    error={Boolean(errors.name)}
                                    helperText={errors.name}
                                    onFocus={() => handleError('', 'name')}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    fullWidth
                                    error={Boolean(errors.email)}
                                    helperText={errors.email}
                                    onFocus={() => handleError('', 'email')}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Phone"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    fullWidth
                                    error={Boolean(errors.phone)}
                                    helperText={errors.phone}
                                    onFocus={() => handleError('', 'phone')}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    label="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    fullWidth
                                    error={Boolean(errors.password)}
                                    helperText={errors.password}
                                    onFocus={() => handleError('', 'password')}
                                />
                            </Grid>


                            <Grid item xs={12}>
                                <FormControl fullWidth error={Boolean(errors.role)}>
                                    <InputLabel id="demo-simple-select-label">Role</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={role || ''}
                                        label="Role"
                                        onChange={(e) => setRole(e.target.value)}
                                    >
                                        <MenuItem value={'manager'}>Manager</MenuItem>
                                        <MenuItem value={'hr'}>HR</MenuItem>
                                    </Select>
                                    {errors.role && <FormHelperText style={{ color: '#d32f2f' }}>{errors.role}</FormHelperText>}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} style={{ display: 'flex', gap: 10 }}>
                                <Button
                                    variant="outlined"
                                    style={{
                                        textTransform: 'capitalize',
                                        color: primaryColor,
                                        border: `1px solid ${primaryColor}`,
                                        borderRadius: 0,
                                    }}
                                    fullWidth
                                    onClick={handleClose}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    style={{
                                        textTransform: 'capitalize',
                                        color: '#fff',
                                        background: primaryColor,
                                        borderRadius: 0,
                                    }}
                                    onClick={handleSubmit}
                                    fullWidth
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : isUpdate ? 'Edit' : 'Save'}
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}
